import React from 'react';
import { Alert, Platform, Text, View } from 'react-native';
import i18n from './../util/i18n';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { getSongs, deleteSong } from '../services/song.service';
import { Button, Card, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { getCategory } from '../services/category.service';

i18n.locale = navigator.language;

class Songs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            category_id: this?.props?.route?.params?.category || null,
            category: null,
            loading: false,
            songs: []
        };
    }

    async componentDidMount() {
        this.focusListener = this.props.navigation.addListener('focus', () => {
            this.setSongs();
            this.setCategory();
        });
        this.setSongs();
        this.setCategory();
    }

    componentWillUnmount() {
        if (this.focusListener) {
            this.focusListener();
        }
    }

    setCategory = async () => {
        let category_id = this.state.category_id;
        let category = await getCategory(category_id);
        this.setState({ category: category.category });
    }

    setSongs = async () => {
        let songs = await getSongs({
            category: this.state.category_id
        });
        this.setState({ songs: songs?.songs ?? [] });
    }

    render() {
        return (
            <View>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <View
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                this.props.navigation.navigate('Categories');
                            }}
                        >
                            <Text style={{ padding: 10, fontSize: 25 }}>
                                {i18n.t('categories')}
                            </Text>
                        </View>
                        <ArrowForwardIosIcon fontSize={'small'} sx={{ marginRight: 2, marginLeft: 2 }} />
                        <Text style={{ padding: 10, fontSize: 25 }}>
                            {this.state.category?.name ?? ''}
                        </Text>
                        {this.state.category?.name ? (<ArrowForwardIosIcon fontSize={'small'} sx={{ marginRight: 2, marginLeft: 2 }} />) : null}
                        <Text style={{ padding: 10, fontSize: 25 }}>
                            {i18n.t('songs')}
                        </Text>
                    </View>
                    <Button
                        size='small'
                        variant='contained'
                        onClick={() => {
                            this.props.navigation.navigate('AddEditSong', { category: this.state.category_id });
                        }}
                    >
                        + {i18n.t('add')}
                    </Button>
                </View>

                <View>

                    <TableContainer component={Card}>
                        <Table borderstyle={{ borderWidth: 2, borderColor: '#c8e1ff' }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{i18n.t('sl_no')}</TableCell>
                                    <TableCell>{i18n.t('audio')}</TableCell>
                                    <TableCell>{i18n.t('release')}</TableCell>
                                    <TableCell>{i18n.t('artist')}</TableCell>
                                    <TableCell>{i18n.t('movie')}</TableCell>
                                    <TableCell>{i18n.t('language')}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {(this.state.songs.length > 0) ? this.state.songs.map((song, index) => {
                                    return (
                                        <TableRow key={song._id}>
                                            <TableCell>{song.sl_no}</TableCell>
                                            <TableCell>{song?.audio_source == 'audio_upload' ? song?.audio_file?.path : song.spotify_url}</TableCell>
                                            <TableCell>{song.release?.title ?? ''}</TableCell>
                                            <TableCell>{song.artist?.name ?? ''}</TableCell>
                                            <TableCell>{song.movie?.name ?? ''}</TableCell>
                                            <TableCell>{song.language?.name ?? ''}</TableCell>
                                            <TableCell>
                                                <Stack direction="row" spacing={2} justifyContent="space-around" sx={{ margin: 1 }}>
                                                    <Button
                                                        size='small'
                                                        variant='contained'
                                                        onClick={() => {
                                                            this.props.navigation.navigate('AddEditSong', { song: song._id, category: this.state.category_id });
                                                        }}
                                                    >
                                                        {i18n.t('edit')}
                                                    </Button>
                                                    <Button
                                                        size='small'
                                                        variant='contained'
                                                        color='error'
                                                        onClick={async () => {
                                                            // delete song
                                                            if (Platform.OS === 'web') {
                                                                if (window.confirm(i18n.t('are_you_sure_you_want_to_delete_this_song'))) {
                                                                    await deleteSong(song._id);
                                                                    this.setSongs();
                                                                }
                                                            } else {
                                                                Alert.alert(
                                                                    i18n.t('confirm_delete'),
                                                                    i18n.t('are_you_sure_you_want_to_delete_this_song'),
                                                                    [
                                                                        {
                                                                            text: i18n.t('cancel'),
                                                                            onPress: () => console.log('Cancel Pressed'),
                                                                            style: 'cancel'
                                                                        },
                                                                        {
                                                                            text: i18n.t('delete'),
                                                                            onPress: async () => {
                                                                                await deleteSong(song._id);
                                                                                this.setSongs();
                                                                            }
                                                                        }
                                                                    ]
                                                                );
                                                            }
                                                        }}
                                                    >
                                                        {i18n.t('delete')}
                                                    </Button>
                                                </Stack>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }) : null}
                            </TableBody>
                        </Table>
                    </TableContainer>

                </View>
                
                
            </View>
        )
    }
}

export default Songs;
